import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const size = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_3742_1297" fill="white">
        <rect x="1.33333" y="1.33334" width="6" height="13.3333" rx="1" />
      </mask>
      <rect
        x="1.33333"
        y="1.33334"
        width="6"
        height="13.3333"
        rx="1"
        stroke="currentColor"
        strokeWidth="2.8"
        mask="url(#path-1-inside-1_3742_1297)"
      />
      <mask id="path-2-inside-2_3742_1297" fill="white">
        <rect x="8.66667" y="1.33334" width="6" height="6.66667" rx="1" />
      </mask>
      <rect
        x="8.66667"
        y="1.33334"
        width="6"
        height="6.66667"
        rx="1"
        stroke="currentColor"
        strokeWidth="2.8"
        mask="url(#path-2-inside-2_3742_1297)"
      />
      <path d="M11.6667 10V14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9.66667 12H13.6667"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  default: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.8" y="2.8" width="7.4" height="18.4" rx="1.2" stroke="currentColor" strokeWidth="1.6" />
      <rect x="13.8" y="2.8" width="7.4" height="8.4" rx="1.2" stroke="currentColor" strokeWidth="1.6" />
      <path d="M17.5 15V21" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 18H20.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.56666" y="3.56666" width="10.2" height="24.8667" rx="1.1" stroke="currentColor" strokeWidth="1.8" />
      <rect x="18.2333" y="3.56666" width="10.2" height="11.5333" rx="1.1" stroke="currentColor" strokeWidth="1.8" />
      <path d="M23.3333 20V28" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M19.3333 24H27.3333"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

function ProgramsIcon(props: Omit<SvgIconProps, "fontSize"> & { fontSize?: "large" | "small" }) {
  const item = size[props.fontSize || "default"];

  return (
    <SvgIcon {...props} fontSize={props.fontSize}>
      {item}
    </SvgIcon>
  );
}
export default ProgramsIcon;
